import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";

import "./Styles/BranchForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from "@mui/material";
const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function BranchRoleForm(props) {
  const [branchRolesSelected, setBranchRolesSelected] = useState([]);
  const [object, setObject] = useState({
    name: props?.object?.name,
    id: props?.object?.id,
    roles:props?.object?.roles
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [roles, setRoles] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;

  //get data of varieties Carrier ....
  const getDataOfRoles = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/roles_list",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      if (data) {
        if (data.status == 200) {
          setRoles(data.data);
          if (props && props.object && props.object.id > 0) {
            if (props.object.roles && props.object.roles.length > 0) {
              console.log("in");
              setBranchRolesSelected(props.object.roles.map((role) => role.id))
            }

            setObject({ ...object, ...props?.object });
          }
          else {

            setObject(
              {
                name: "",
                id: "",
                roles:[]
              }
            )
          }
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };
  useEffect(() => {
    getDataOfRoles(ApiSettings.apiUrl);
  }, [props.object]);

  //here we will sent request with data to save it in our database.
  const sentFormData = async () => {

    // console.log("branchRolesSelected",branchRolesSelected);
    // return ;
    setLoading(true);

    let data = null;
    try {
      let formdata = new FormData();
      branchRolesSelected.map((branchRole,index)=>{
        formdata.append("roles["+index+"]", branchRole);
      })
     
      data = await axios({
        method: "put",
        url: ApiSettings.apiUrl + "/branches/roles/" + object.id,
        data: {
          roles:branchRolesSelected
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      console.log("update", data);
      if (data) {
        if (data.data.status == 200) {
          setLoading(false);

          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          props.setReloadData()
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  const handleInputChange = (event, role_id) => {
    const target = event.target;
    // console.log("ischecked",target.checked);
    if (target.checked) {
      setBranchRolesSelected([...branchRolesSelected, role_id])
    }
    else {
      const branchRolesSelectedtemp = branchRolesSelected.filter(function (item) {
        return item !== role_id
      })
      setBranchRolesSelected(branchRolesSelectedtemp)
    }
  };


  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${props.inactive === false ? "activeSideMenu" : ""
        }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">المسميات الوظيفية للفرع {object.name}</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12 align-items-center  d-flex " style={{
            flexDirection: 'column',
            borderStyle: 'solid',
            borderColor: 'rgb(95, 123, 138)',
            borderWidth: '2px',
            borderRadius: '10px',
            paddingTop: '10px',
            paddingBottom: '10px'
          }}>
            
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormLabel component="legend">اختر من المسميات الوظيفية التالية</FormLabel>
              <FormGroup>
              {roles.map((role,index) => {
                var isChecked = false;
                if (branchRolesSelected.length > 0 && branchRolesSelected.includes(role.id)) {
                  isChecked = true;
                }
                return <FormControlLabel
                key={index+"_branch_role"}
                  control={
                    <Checkbox checked={isChecked} onChange={(e) => handleInputChange(e, role.id)} name="gilad" />
                  }
                  label={role.name}
                />
              })}
                
              </FormGroup>
              <FormHelperText>تستطيع اختيار اكثر من واحدة</FormHelperText>
            </FormControl>




            <Button
              variant="contained"
              className="mx-3 section1CarrerName section1Button mt-4 pt-1"
              onClick={() => {
                sentFormData();
              }}
            >
              {!loading ? (
                "تحديث"
              ) : (
                <div className="spinner-border " role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </Button>

          </div>
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
